import { render, staticRenderFns } from "./one-stop.vue?vue&type=template&id=a3b378e6&scoped=true&"
import script from "./one-stop.vue?vue&type=script&lang=js&"
export * from "./one-stop.vue?vue&type=script&lang=js&"
import style0 from "./one-stop.vue?vue&type=style&index=0&id=a3b378e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b378e6",
  null
  
)

export default component.exports